(function () {
  function getLabel(input) {
    if (!input || !input.id) {
      return null;
    }
    return document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isValidRadio(input) {
    if (!input || input.disabled) {
      return false;
    }
    var label = getLabel(input);
    return !(label && !isVisible(label));
  }

  function normalizeFieldset(fieldset) {
    var radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    if (!radios.length) {
      return false;
    }
    var checked = radios.find(function (radio) {
      return radio.checked;
    });
    if (checked && isValidRadio(checked)) {
      return false;
    }
    var firstValid = radios.find(isValidRadio);
    if (!firstValid || firstValid.checked) {
      return false;
    }
    firstValid.checked = true;
    firstValid.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function normalizeSelect(select) {
    if (!select) {
      return false;
    }
    var current = select.options[select.selectedIndex];
    if (current && !current.disabled) {
      return false;
    }
    var firstValid = Array.from(select.options).find(function (option) {
      return !option.disabled && option.value !== '';
    });
    if (!firstValid || select.value === firstValid.value) {
      return false;
    }
    select.value = firstValid.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function normalizeVariantPickers(root) {
    (root || document).querySelectorAll('product-info').forEach(function (productInfo) {
      var variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) {
        return;
      }
      var fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
      var selects = Array.from(variantSelects.querySelectorAll('select'));

      if (fieldsets.length) {
        for (var i = 1; i < fieldsets.length; i += 1) {
          if (normalizeFieldset(fieldsets[i])) {
            return;
          }
        }
      }

      if (selects.length) {
        for (var j = 1; j < selects.length; j += 1) {
          if (normalizeSelect(selects[j])) {
            return;
          }
        }
      }
    });
  }

  var rafId = null;
  function scheduleNormalize() {
    if (rafId) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(function () {
      normalizeVariantPickers(document);
      rafId = null;
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleNormalize);
  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-selects')) {
      scheduleNormalize();
    }
  });
  new MutationObserver(scheduleNormalize).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

(function () {
  if (!/\/pages\/papalove-unlock-payment\/?$/.test(window.location.pathname)) {
    return;
  }

  var replacements = [
    ['Mia liked you. Reveal what she sent.', 'She liked you. Reveal what she sent.'],
    ["Reveal Mia's locked message", 'Reveal her locked message'],
    ['Mia liked you', 'She liked you'],
    ['Mia, 24', 'She'],
    ['Mia:', 'She:'],
    ["Reveal Mia's message", 'Reveal her message'],
    ['Reveal Mia now', 'Reveal now']
  ];

  function replaceString(value) {
    if (!value) {
      return value;
    }
    return replacements.reduce(function (current, pair) {
      return current.split(pair[0]).join(pair[1]);
    }, value);
  }

  function patchTextNodes(root) {
    if (!root) {
      return;
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node = walker.nextNode();
    while (node) {
      var nextValue = replaceString(node.nodeValue);
      if (nextValue !== node.nodeValue) {
        node.nodeValue = nextValue;
      }
      node = walker.nextNode();
    }
  }

  function patchAttributes() {
    document.title = replaceString(document.title);
    document.querySelectorAll('meta[content], [aria-label], [alt], [title]').forEach(function (element) {
      ['content', 'aria-label', 'alt', 'title'].forEach(function (attribute) {
        if (element.hasAttribute(attribute)) {
          element.setAttribute(attribute, replaceString(element.getAttribute(attribute)));
        }
      });
    });
  }

  function patchPhotoBlur() {
    if (document.getElementById('papalove-cache-text-patch')) {
      return;
    }
    var style = document.createElement('style');
    style.id = 'papalove-cache-text-patch';
    style.textContent = [
      '.profile-unlock__photo { filter: blur(24px) saturate(1.02) !important; transform: scale(1.12) !important; }',
      '.profile-unlock.is-peeking .profile-unlock__photo,',
      '.profile-unlock__photo-card:focus .profile-unlock__photo,',
      '.profile-unlock__photo-card:hover .profile-unlock__photo { filter: blur(18px) saturate(1.04) !important; transform: scale(1.095) translateY(-4px) !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function patchPage() {
    patchTextNodes(document.body);
    patchAttributes();
    patchPhotoBlur();
  }

  patchPage();
  document.addEventListener('DOMContentLoaded', patchPage);
  window.setTimeout(patchPage, 100);
  window.setTimeout(patchPage, 500);
  window.setTimeout(patchPage, 1500);

  var observer = new MutationObserver(patchPage);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    observer.disconnect();
  }, 10000);
})();
